// extracted by mini-css-extract-plugin
module.exports = {"cart-item-price":"ContentPrice_cart-item-price__hVHdD","strike":"ContentPrice_strike__mk_NX","promotion-percent":"ContentPrice_promotion-percent__Idtz5"};